import { WatchQueryFetchPolicy } from '@apollo/client';
import { useLocation } from 'react-router-dom';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { GET_PDF_PREVIEWS } from './pdf-preview.graphql';
import type {
  GetPdfPreviewsQuery,
  GetPdfPreviewsQueryVariables,
} from './pdf-preview.graphql.generated';
import { studentAuthApolloContextOption } from 'approot/student-class-to-do/student-class-to-do.utils';
import { isStudentOnStudentPage } from 'approot/students/logic/is-student-on-student-page';

const useGetPDFPreviews = ({
  documentKey,
  previewSize,
  previewWidth,
  previewHeight,
  fetchPolicy,
  skip,
  onCompleted,
}: {
  documentKey: string;
  previewSize: number;
  previewWidth?: number;
  previewHeight?: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  onCompleted?: (data: GetPdfPreviewsQuery) => void;
}) => {
  const location = useLocation();
  const isStudent = isStudentOnStudentPage(location);

  const { data, loading, error } = useLoggingQuery<
    GetPdfPreviewsQuery,
    GetPdfPreviewsQueryVariables
  >(
    GET_PDF_PREVIEWS,
    {
      ...(isStudent ? { context: studentAuthApolloContextOption() } : {}),
      fetchPolicy: fetchPolicy || 'cache-first',
      variables: {
        input: {
          key: documentKey,
          size: previewSize,
          width: previewWidth,
          height: previewHeight,
        },
      },
      skip: !documentKey || skip,
      onCompleted: res => onCompleted?.(res),
    },
    !isStudent
  );

  return {
    loading,
    data,
    error,
  };
};

export default useGetPDFPreviews;
